<div class="h-full w-full p-4 flex flex-col items-center overflow-y-auto custom-scrollbar relative">

  <header class="text-center mb-8 max-w-2xl shrink-0 mt-4">
    <h1 class="text-3xl lg:text-4xl font-bold text-heading tracking-tight mb-3">
      {{ config.texts.selectTitle }}
    </h1>
    <p class="text-secondary-text text-lg">
      {{ config.texts.selectSubtitle }}
    </p>
  </header>

  <div
       class="w-full max-w-[1200px] mb-8 flex flex-col md:flex-row gap-4 justify-between items-center shrink-0 bg-component-inner border border-primary-border rounded-xl p-4 shadow-sm">
    <div class="w-full md:w-1/3">
      <nz-input-group [nzPrefix]="searchIcon"
                      class="w-full">
        <input type="text"
               nz-input
               class="bg-input-background text-primary-text border-secondary-border"
               [placeholder]="config.texts.searchPlaceholder"
               [ngModel]="searchQuery()"
               (ngModelChange)="onSearchChange($event)" />
      </nz-input-group>
      <ng-template #searchIcon><i class="fas fa-search text-secondary-text"></i></ng-template>
    </div>

    <div class="flex gap-4 w-full md:w-auto">
      <nz-select [ngModel]="sortValue()"
                 (ngModelChange)="sortValue.set($event); resetAndFetchProjects()"
                 class="w-full md:w-48"
                 nzPlaceHolder="Sort by">
        <nz-option nzValue="dateDesc"
                   [nzLabel]="config.texts.sortDateDesc"></nz-option>
        <nz-option nzValue="dateAsc"
                   [nzLabel]="config.texts.sortDateAsc"></nz-option>
        <nz-option nzValue="alphabetical"
                   [nzLabel]="config.texts.sortAlphabetical"></nz-option>
      </nz-select>

      <nz-select [ngModel]="filterValue()"
                 (ngModelChange)="filterValue.set($event); resetAndFetchProjects()"
                 class="w-full md:w-48"
                 nzPlaceHolder="Filter by">
        <nz-option nzValue="all"
                   [nzLabel]="config.texts.filterAll"></nz-option>
        <nz-option nzValue="favorited"
                   [nzLabel]="config.texts.filterFavorited"></nz-option>
        <nz-option nzValue="shared"
                   [nzLabel]="config.texts.filterShared"></nz-option>
        <nz-option nzValue="owned"
                   [nzLabel]="config.texts.filterOwned"></nz-option>
      </nz-select>
    </div>
  </div>

  @if (isLoading()) {
  <div class="flex items-center justify-center p-12 flex-1">
    <i class="fas fa-circle-notch fa-spin text-4xl text-primary"></i>
  </div>
  } @else {

  @if (localProjects().length === 0) {
  <div
       class="text-center p-12 bg-component-inner border border-primary-border rounded-xl w-full max-w-2xl mx-auto shrink-0">
    <i class="fas fa-folder-open text-4xl text-secondary-text mb-4"></i>
    <p class="text-primary-text">{{ config.texts.emptyState }}</p>
  </div>
  } @else {

  <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 w-full max-w-[1200px] pb-6 shrink-0">
    @for (project of localProjects(); track project.id) {
    <button (click)="onSelectWorkspace(project)"
            class="card-container group relative flex flex-col bg-alt-background border border-primary-border rounded-xl shadow-sm hover:border-secondary-border hover:shadow-default transition-all duration-300 cursor-pointer overflow-hidden min-h-[260px] text-left">

      <div class="h-[60px] w-full bg-cover rounded-t-xl bg-center bg-alt-background relative shrink-0 border-b border-primary-border"
           [style.backgroundImage]="'url(' + getCardImage(project.id) + ')'">

        <div
             class="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-200 rounded-t-xl">
        </div>

        <button (click)="toggleFavorite($event, project)"
                nz-tooltip
                [nzTooltipTitle]="favoriteIds().has(project.id) ? config.texts.removeFavorite : config.texts.markFavorite"
                class="absolute top-2 right-2 p-1.5 rounded-full bg-white/90 backdrop-blur-sm hover:bg-white transition-colors shadow-sm focus:outline-none cursor-pointer z-10"
                [ngClass]="favoriteIds().has(project.id) ? 'text-primary' : 'text-secondary-text hover:text-primary'">
          <i class="fa-star text-sm"
             [ngClass]="favoriteIds().has(project.id) ? 'fas' : 'far'"></i>
        </button>
      </div>

      <div class="flex flex-col flex-1 p-5 min-h-0 bg-component-inner rounded-b-xl">
        <h3
            class="text-xl font-bold text-heading group-hover:text-primary transition-colors duration-100 truncate">
          {{ project.name }}
        </h3>

        <div class="mt-2 text-xs text-secondary-text flex flex-col gap-1">
          <span class="truncate">{{ config.texts.createdBy }} <span
                  class="font-medium text-heading">{{
              project.createdBy || 'System' }}</span></span>
          <span class="truncate">{{ config.texts.onDate }} {{ project.createdDate | date:'longDate' }}</span>
        </div>

        <div class="flex-1"></div>

        <div class="flex justify-end mt-4">
          <div nz-tooltip
               [nzTooltipTitle]="config.texts.goToWorkspace"
               nzTooltipPlacement="left"
               class="w-10 h-10 rounded-full bg-alt-background text-secondary-text border border-secondary-border group-hover:bg-primary group-hover:text-primary-button-text group-hover:border-primary transition-all duration-200 flex items-center justify-center shadow-sm">
            <i
               class="fas fa-arrow-right text-sm transform group-hover:translate-x-0.5 transition-transform duration-200"></i>
          </div>
        </div>
      </div>
    </button>
    }
  </div>

  @if (hasMoreProjects()) {
  <div class="w-full flex justify-center mt-4 mb-12 shrink-0">
    <button (click)="fetchProjects(false)"
            [disabled]="isPaginating()"
            class="px-8 py-3 bg-component-inner border border-secondary-border rounded-lg text-primary-text font-medium hover:border-primary hover:text-primary transition-all shadow-sm disabled:opacity-50 flex items-center gap-2 cursor-pointer">
      @if (isPaginating()) {
      <i class="fas fa-circle-notch fa-spin"></i>
      }
      {{ config.texts.loadMore }}
    </button>
  </div>
  }
  }
  }
</div>